import { asyncPreactWidget } from '../../utils/async-preact-widget';
import { carouselInline } from '../../preact/widgets';
import { b64DecodeUnicode } from '../../utils/base64-utils';
import { getLocation } from '../../utils/build-urls';
import { IS_HIDDEN_CLASSNAME, removeElementDom, unHideElement } from '../../utils/dom-utils';

import { MOBILE_CAROUSEL_CLASSNAME_SELECTOR } from './constants';

export const CAROUSEL_INLINE_CLASSNAME = '.carouselInline';
const ARTICLE_INFO_CLASSNAME = '.s-article-info';
const ARTICLE_SECTION_CLASSNAME = '.c-article-section';

export const initPreactCarousel = () => {
  const widget = asyncPreactWidget(carouselInline);
  if (widget.isOnPage()) {
    widget.start();
    import(`../../preact/widgets/carousel-inline`).then(widget.hydrate).catch(widget.error);
  }
};

export const movePreactCarousel = () => {
  const $carouselInline = document.querySelector(CAROUSEL_INLINE_CLASSNAME);
  const $articleInfo = document.querySelector(ARTICLE_INFO_CLASSNAME);
  const $articleSection = document.querySelector(ARTICLE_SECTION_CLASSNAME);
  if ($carouselInline && $articleSection) {
    if ($articleInfo) {
      $articleInfo.parentNode.insertBefore($carouselInline, $articleInfo.nextSibling);
    } else {
      $articleSection.parentNode.insertBefore($carouselInline, $articleSection.nextSibling);
    }
  }
};

export const redirectToFirstVideoUrl = () => {
  const $carouselInline = document.querySelector(CAROUSEL_INLINE_CLASSNAME);
  const carouselData = JSON.parse(b64DecodeUnicode($carouselInline.dataset.jsonBase64));
  const locationWithPathname = getLocation().withPathName;
  const mappedCardList = carouselData?.cardList?.filter((card) => card.url !== locationWithPathname);
  const firstVideo = mappedCardList[0] || undefined;
  if (firstVideo) {
    window.location.href = firstVideo.url;
  }
};

export const switchMobileCards = () => {
  const container = document?.querySelector(MOBILE_CAROUSEL_CLASSNAME_SELECTOR);
  if (!container) {
    return;
  }
  let wasChildRemoved = false;
  const currentUrl = window.location.href;
  const children = Array.from(container.children);

  children.forEach((child, index) => {
    if (child.tagName === 'A' && child.href === currentUrl) {
      removeElementDom(child);
      wasChildRemoved = true;
    }

    if (wasChildRemoved && child.classList.contains(IS_HIDDEN_CLASSNAME)) {
      unHideElement(child);
    }
  });
};
